/* template */
<template><div class="loading"><div class="loading-icon"><div class="inner"/></div><div>加载中…</div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mba41c4a6"}'>
  .loading
    display flex
    justify-content center
    align-items center
    width 100%
    height 120rpx
    font-family PingFangSC-Regular
    font-size 20rpx
    color #666666
    font-weight 400
  .loading-icon
    display flex
    align-items center
    justify-content center
    width 26rpx
    height 26rpx
    margin-right 16rpx
    border-radius 50%
    background conic-gradient(#CCCCCC 0, #CCCCCC 75%, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0) 100%)
    box-sizing border-box
    animation rotate 800ms linear infinite
    @keyframes rotate
      0%
        transform rotate(0)
      50%
        transform rotate(180deg)
      100%
        transform rotate(360deg)
    .inner
      width 20rpx
      height 20rpx
      border-radius 50%
      background-color #f6f8fb
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mba41c4a6"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./loading.mpx.js?isComponent&outputPath=components%2Floadingba41c4a6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./loading.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Floadingba41c4a6%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mba41c4a6"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/loadingba41c4a6/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
